import { inject, observer } from "mobx-react";
import React, { Component } from 'react';

@inject('igStore')
@observer
class EventHeader extends Component {
  render() {
    if (this.props.igStore.error) return null;

    const { sid, c1, c2, score } = this.props.igStore.game;

    return <div className={`ig-event-header s-c-${sid}`}>
      <div className="ig-teams">
        <div className="ig-team" title={c1}>
          <div className="ig-team-text">{c1}</div>
        </div>
        <div className="ig-team" title={c1}>
          <div className="ig-team-text">{c2}</div>
        </div>
      </div>
      <div className="ig-score">{score}</div>
    </div>
  }
}

export default EventHeader;


// WEBPACK FOOTER //
// ./src/components/ig/eventHeader.js